import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { login } from "../../features/auth/authSlice";
import { selectAuthState, selectIsAuthenticated } from "../../features/auth/authSelectors";

function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { status, error } = useSelector(selectAuthState);
  const isAuthed = useSelector(selectIsAuthenticated);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (isAuthed) navigate("/home", { replace: true });
  }, [isAuthed, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(login({ username, password }));
  };

  return (
    <div className="min-h-screen bg-background flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img
          className="mx-auto h-24 w-auto drop-shadow-md"
          src="/images/National-Emblem.png"
          alt="National Emblem"
        />
        <h2 className="mt-6 text-center text-3xl font-extrabold text-text tracking-tight">
          MAA Canteen Monitoring
        </h2>
        <h3 className="mt-2 text-center text-2xl font-extrabold text-text tracking-tight" style={{color: "#02bd0b"}}>
          Welcome Back
        </h3>
        <p className="mt-2 text-center text-sm text-text-muted">
          State Urban Development Agency <br />
          <span className="font-semibold text-primary mt-1 inline-block">Government of West Bengal</span>
        </p>
      </div>

      <div className="rounded-2xl mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-surface py-8 px-4 shadow-xl sm:rounded-2xl sm:px-10 border border-border">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="username" className="block text-sm font-medium text-text-muted mb-1">
                Username
              </label>
              <input
                id="username"
                name="username"
                type="text"
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="appearance-none block w-full px-4 py-3 border border-border rounded-lg shadow-sm placeholder-text-disabled focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent sm:text-sm bg-background text-text transition-all duration-200"
                placeholder="Enter your username"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-text-muted mb-1">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="appearance-none block w-full px-4 py-3 border border-border rounded-lg shadow-sm placeholder-text-disabled focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent sm:text-sm bg-background text-text transition-all duration-200"
                placeholder="Enter your password"
              />
            </div>

            <div>
              <button
                type="submit"
                disabled={status === "loading"}
                className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-md text-sm font-semibold text-secondary bg-primary hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-70 disabled:cursor-not-allowed transition-all duration-200 active:scale-[0.98]"
              >
                {status === "loading" ? "Logging in..." : "Login to Account"}
              </button>
            </div>

            {error && (
              <div className="p-3 rounded-lg bg-red-50 border border-red-100 text-center animate-pulse">
                <p className="text-sm font-medium text-error">{error}</p>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;

